module.exports = __webpack_public_path__ + "img/组 5.2bc53ea7.png";